import { ArrowContainer } from '@hellodarwin/core/lib/components/common/button/arrow/styles';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled, { css } from 'styled-components';
const StepCardBodyInRowStyle = css `
  align-items: flex-start;
  text-align: left;
`;
const StepCardBodyInColumnStyle = css `
  align-items: center;
  text-align: center;
`;
export const StepCardBody = styled.div `
  position: relative;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;
const StepCardCoverRowStyle = css `
  max-width: 280px;
  height: 189px;
`;
const StepCardCoverInColumnStyle = css `
  max-width: 100%;
  height: 248px;
`;
export const StepCardCover = styled.div `
  border-radius: ${({ theme }) => theme.border_radius.sm};;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  background: ${({ theme }) => theme.colors.beige_3};
  width: 100%,
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  img {
    width: 100%;
    object-fit: contain;
    -webkit-user-drag: none;
  }
  user-select: none;
`;
const StepCardContainerRowStyle = css `
  flex-direction: row;
  gap: 56px;
`;
const StepCardContainerColumnStyle = css `
  flex-direction: column;
  gap: 24px;
`;
export const StepCardContainer = styled.div `
  ${({ $isRow }) => $isRow ? StepCardContainerRowStyle : StepCardContainerColumnStyle}
  border: 1px solid ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.beige_1};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  padding: 24px;
  z-index: 2;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  display: flex;
  position: relative;
  align-items: center;
  height: ${({ $withCta }) => ($withCta ? '100%' : 'auto')};
  ${ArrowContainer} {
    width: 30px;
  }
  ${StepCardBody} {
    ${({ $isRow }) => $isRow ? StepCardBodyInRowStyle : StepCardBodyInColumnStyle}
  }
  ${StepCardCover} {
    ${({ $isRow }) => $isRow ? StepCardCoverRowStyle : StepCardCoverInColumnStyle}
  }

  ${media.tablet `
    ${StepCardContainerColumnStyle}
    ${StepCardBody} {
      ${StepCardBodyInColumnStyle}
    }
    ${StepCardCover} {
      ${StepCardCoverInColumnStyle}
    }
  `}
  ${({ $hoverable, theme }) => $hoverable
    ? `
        &:hover{
          box-shadow: ${theme.appearance.box_shadow_hover};
          transform:translateY(-2px);
          background: ${theme.colors.beige_2};
        `
    : ''}
`;
export const StepNumberContainer = styled.div `
  position: absolute;
  right: 8px;
  bottom: -2px;
  text-align: right;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.beige_1};
  text-shadow:
    -1px 0 ${({ theme }) => theme.colors.grey_4},
    1px 0 ${({ theme }) => theme.colors.grey_4},
    0 -1px ${({ theme }) => theme.colors.grey_4};
`;
